import permisosCompras, { RESOURCE_COMPRAS } from '@/auth/permissions/modules/compras'
import * as names from '@routes/compras/nombres/informes'
import type { MenuConfig } from '~typings/menu'

const { informes } = permisosCompras
export default [
    {
        title: 'compras.subopciones.solicitudes_x_status',
        route: names.ROUTE_SOLICITUDES_X_STATUS,
        resource: RESOURCE_COMPRAS,
        action: informes.solicitudesXStatus,
    },
    {
        title: 'compras.subopciones.solicitudes_x_item',
        route: names.ROUTE_SOLICITUDES_X_ITEM,
        resource: RESOURCE_COMPRAS,
        action: informes.solicitudesXItem,
    },
    {
        title: 'compras.subopciones.ordenes_compra_x_status',
        route: names.ROUTE_ORDENES_COMPRA_X_STATUS,
        resource: RESOURCE_COMPRAS,
        action: informes.ordenesCompraXStatus,
    },
    {
        title: 'compras.subopciones.items_x_orden_compra',
        route: names.ROUTE_ITEM_X_ORDENES_COMPRA,
        resource: RESOURCE_COMPRAS,
        action: informes.itemXOrdenesCompra,
    },
    {
        title: 'compras.subopciones.historial_precios',
        route: names.ROUTE_HISTORIAL_PRECIOS,
        resource: RESOURCE_COMPRAS,
        action: informes.historialPrecios,
    },
    {
        title: 'compras.subopciones.orden_compra_vs_recepcion_bodega',
        route: names.ROUTE_ORDENES_COMPRA_VS_RECEPCION_BODEGA,
        resource: RESOURCE_COMPRAS,
        action: informes.ordenesCompraVsRecepcionBodega,
    },
    {
        title: 'compras.subopciones.seguimiento_solicitudes',
        route: names.ROUTE_SEGUIMIENTO_SOLICITUDES,
        resource: RESOURCE_COMPRAS,
        action: informes.seguimientoSolicitudes,
    },
    {
        title: 'compras.subopciones.costos_cotizaciones',
        route: names.ROUTE_COSTOS_COTIZACIONES,
        resource: RESOURCE_COMPRAS,
        action: informes.costosCotizaciones,
    },
    {
        title: 'compras.subopciones.cotizaciones',
        route: names.ROUTE_COTIZACIONES,
        resource: RESOURCE_COMPRAS,
        action: informes.cotizaciones,
    },
    {
        title: 'compras.subopciones.ordenes_entrega_x_status',
        route: names.ROUTE_ORDENES_ENTREGA_X_STATUS,
        resource: RESOURCE_COMPRAS,
        action: informes.ordenesEntregaXStatus,
    },
    {
        title: 'compras.subopciones.recepciones_orden_entrega',
        route: names.ROUTE_RECEPCIONES_ORDEN_ENTREGA,
        resource: RESOURCE_COMPRAS,
        action: informes.recepcionesOrdenEntrega,
    },
] as MenuConfig[]
